import { css } from 'styled-components';

export const alignToContainerLeft = () => css`
	@media(min-width: 1300px) {
		margin-left: calc((100% - 1300px) / 2);
	}
`;

export const alignToContainerRight = () => css`
	@media(min-width: 1300px) {
		margin-right: calc((100% - 1300px) / 2);
	}
`;
